import { select, Store } from '@ngneat/elf';
import { Injectable } from '@angular/core';
import { BaseStoreRepository } from '@/store/base-store.repository';
import {
  dacTransactionalFormAssignmentInitialState,
  DacTransactionalFormAssignmentStateProps,
  dacTransactionalFormAssignmentStore,
} from './dac-transactional-form-assignment-state.store';

export type DacTransactionalFormAssignmentStore = Store<
  {
    name: string;
    state: DacTransactionalFormAssignmentStateProps;
    config: undefined;
  },
  DacTransactionalFormAssignmentStateProps
>;

@Injectable({ providedIn: 'root' })
export class DacTransactionalFormAssignmentRepositoryFactory {
  static create(store: DacTransactionalFormAssignmentStore) {
    return new DacTransactionalFormAssignmentRepository(store);
  }
}

export class DacTransactionalFormAssignmentRepository extends BaseStoreRepository<DacTransactionalFormAssignmentStateProps> {
  constructor(store?: DacTransactionalFormAssignmentStore) {
    if (store) super(store.pipe(select(state => state)), store, { ...dacTransactionalFormAssignmentInitialState });
    else
      super(
        dacTransactionalFormAssignmentStore.pipe(select(state => state)),
        dacTransactionalFormAssignmentStore,
        dacTransactionalFormAssignmentInitialState
      );
  }
}
